export const employmentOptions = [
  'Relación de dependencia',
  'Monotributista',
  'Autónomo / Responsable inscripto',
  'Jubilado / Pensionado',
  'Trabajo informal',
  'Sin empleo actualmente',
];

export const seniorityOptions = ['Menos de 6 meses', 'De 6 a 12 meses', 'De 1 a 3 años', 'Más de 3 años'];

export const bankAccountOptions = ['Sí, con movimientos', 'Sí, sin movimientos', 'No tengo'];

export const tradeInOptions = ['Sí, tengo un auto para entregar', 'No'];

export const guarantorOptions = ['Sí, tengo garante', 'Puedo conseguirlo', 'No tengo'];
